import { render, staticRenderFns } from "./modifyPrices.vue?vue&type=template&id=f497c66a&scoped=true"
import script from "./modifyPrices.vue?vue&type=script&lang=js"
export * from "./modifyPrices.vue?vue&type=script&lang=js"
import style0 from "./modifyPrices.vue?vue&type=style&index=0&id=f497c66a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f497c66a",
  null
  
)

export default component.exports